<template>
  <TemplateConMenuLateral>
    <Banner slot="banner" :titulo="titulo" style="flex: 1 0 100%;" />

    <div slot="menu">
      <button
        v-if="recibo.pagable"
        @click.prevent="urlPago()"
        class="pure-button btnPagar ripple"
        >Pagar recibo</button>

      <button
        v-if="recibo.imprimible && !recibo.esPolizaInternauto"
        class="pure-button btnPagar ripple"
        @click.prevent="imprimirRecibos()"
      >
        <fai :icon="['far', 'file-pdf']" />
        Descargar recibo
      </button>
    </div>

    <div v-if="recibo" slot="contenido" class="tarjetario">
      <DatosRecibo v-if="!recibo.esPolizaInternauto" :recibo="recibo" />
      <DatosReciboInternauto v-else :recibo="recibo" />
    </div>
  </TemplateConMenuLateral>
</template>

<script>
export default {
  computed: {
    recibo() {
      return this.$store.state.seleccion;
    },
    titulo() {
      if (!this.recibo.idRecibo) return "Cargando datos...";
      return `${this.recibo.titulo}`;
    },
  },

  beforeRouteEnter: async function(to, from, next) {
    await fetchData(to.params.idRecibo);
    next();
  },

  beforeRouteUpdate: async function(to, from, next) {
    await fetchData(to.params.idRecibo);
    next();
  },
  methods: {
    imprimirRecibos: async function() {
      this.$store.dispatch("downloadRecibo", this.recibo.idRecibo);
    },
    urlPago: async function () {
      const response=await fetchUrlPago(this.recibo.idRecibo);
      const urlPago=response.data.data;
      window.open(urlPago, '_blank').focus();
    }
  },
};

import store from "@/store/store.js";
async function fetchData(idRecibo) {
  await store.dispatch("getRecibo", idRecibo);
}
async function fetchUrlPago(idRecibo) {
  return await store.dispatch("getUrlPago", idRecibo);
}
</script>

<style lang="scss" scoped>
.btnPagar {
  background-color: $naranjaMMT;
  font-size: 120%;
  color: white;
  width: 100%;
}
</style>
